import BaseItem from "../BaseItem"
import {
  DATA_TYPE__ARRAY, DATA_TYPE__JSON,
  DATA_TYPE__NUMBER,
  DEFAULT_VALUE__CUSTOM,
  DEFAULT_VALUE__FORMULA,
  DEFAULT_VALUE__ID,
  DEFAULT_VALUE__RELATE_DATA, DEFAULT_VALUE__SUB_TABLE_ID, FORM_ITEM__CHECKBOX,
  FORM_ITEM__CURRENCY, FORM_ITEM__DROPDOWN,
  FORM_ITEM__IMAGE,
  FORM_ITEM__NUMBER,
  FORM_ITEM__SINGLE_CHOOSE,
  FORM_ITEM__SINGLE_LINE,
  FORM_ITEM__TABLE
} from "../types"
import SingleLine from "./SingleLine"
import Digital from "./Digital"
import Currency from "./Currency"
import DateInput from "./DateInput"
import DateRange from "./DateRange"
import DropDown from "./Dropdown"
import ExternalDataSource from "./ExternalDataSource"
import YesNo from "./YesNo"
import {defaultValueInit, uuid} from "../utils"
import {clone, getFilterResults, isArray, isObject} from "../../../assets/js/Untis";
import context from '../../main.js'
import store from "../../store";

class Table extends BaseItem {
  constructor() {
    super()
    this.value = []

    this.header = this.children

    this.defaultValue = {
      defaultType: ''
    }

    this.displayRuleMap = {} // 字段显隐信息 { displayId: filterInfo对象}
    this.displayResults = {}
    this.rowCustom = {} // 行号对应自定义属性

    this.closeTableCreate = 0
    this.closeTableDelete = 0
    this.allExpand = 0 // 移动端是否默认全部展开

    this.openDataLoad = 'NO'
    this.dataLoadConfig = null
    this.dataLoadList = []
    this.showTableStyle = 'NO'

    this.errInfo = null

    //分组开关
    this.quickGroup = "NO"//快捷分组开关
    this.quickGroupButton = {
      "buttonTxt": "快捷分组", // 按钮文字
      "buttonColor": "#333333", // 颜色
      "buttonBgColor": "" // 颜色
    }
    //子表单发起
    this.openTableCreate = "NO" //开启子表单
    this.startFormButton = {
      "buttonTxt": "发起表单",
      "buttonColor": "#333333",
      "buttonBgColor": ""
    }
    this.startFormInfo = {
      "sourceType": 0, // 0 当前表单 1 关联表单(先不做)
      "appId": '',
      "formId": "",
      "createMap": [
        // {
        //   "inputType": 0, // 0 具体的值 1 表单字段 2 当前时间 3 相对时间
        //   "inputValue": "填充的值", //填写的具体的值 定时任务的时候 全部为此种类型
        //   "relateType": -1, //-1 之前 1 之后
        //   "days": 1, // 几天
        //   "localFieldId": "", //当前表单field的Id
        //   "remoteFieldId": "" //填充表单的field的Id
        // }
      ]
    } //发起表单信息

    // 记录请求流水号
    this.reqSerMap = {}
  }

  get title() {
    return this.fieldTitle || Table._title
  }

  set title(val) {
    this.fieldTitle = val
    this.temTitle = val
  }
}

Table._title = '表格'
Table.type = FORM_ITEM__TABLE

Table.use = true
Table.icon = 'iconfont icon-biaoge'

Table.prototype.type = Table.type
Table.prototype.dataType = DATA_TYPE__ARRAY

Table.prototype.getValue = function () {
  const value = clone(this.value)
  value.forEach(val => {
    Object.keys(val).forEach(key => {
      const field = this.children.filter(field => field.dataId === key)[0]
      if (field && field.dataType === DATA_TYPE__NUMBER) {
        val[key] = Number(val[key])
      }
    })
  })
  value.forEach(row => {
    delete row.rowCustom
  })
  return value
}
Table.prototype.setValue = function (val) {
  if (!val) {
    this.value = []
    return
  }
  if (Object.prototype.toString.call(val) === '[object Array]') {
    val.forEach(item => {
      const id = uuid('tb')
      if (!item.newId) {
        item.newId = id
      }
      item.id = id
      context.$set(item, 'rowCustom', {})
      if (!item.hasOwnProperty('optionsMap')) {
        context.$set(item, 'optionsMap', {})
        this.children.forEach(field => {
          if ([FORM_ITEM__SINGLE_CHOOSE, FORM_ITEM__DROPDOWN, FORM_ITEM__CHECKBOX].includes(field.type)) {
            context.$set(item.optionsMap, field.dataId, field.options)
          }
        })
      }
      this.children.forEach(field => {
        context.$set(item.rowCustom, field.dataId, {
          showCustom: 0,
          color: field.displayInfo.color,
          alertMsg: field.displayInfo.alertMsg
        })
      })
    })

    // 判断服务器存的value中没有这个字段的value，在这里补一个空的
    const childFieldIds = this.children.map(field => field.dataId)
    val.forEach(item => {
      let arrTmp = []
      childFieldIds.forEach(fieldId => {
        if (!Object.keys(item).includes(fieldId)) {
          arrTmp.push(fieldId)
        }
      })
      arrTmp.forEach(fieldId => {
        const field = this.children.filter(field => field.dataId === fieldId)[0] || null
        if (field.dataType === DATA_TYPE__JSON || field.dataType === DATA_TYPE__ARRAY) {
          item[fieldId] = field ? clone(field.getValue()) : null
        } else {
          item[fieldId] = field ? field.getValue() : null
        }
      })
    })

    this.value.splice(0, this.value.length, ...val)
    this.value.forEach((row, idx) => {
      this.computeDisplayResults(idx)
    })
  } else if (Object.prototype.toString.call(val) === '[object Object]') {
    const id = uuid('tb')
    if (!val.newId) {
      val.newId = id
    }
    val.id = id
    this.value.splice(0, this.value.length, val)
  }
}

// 子表单中某一行数据中的某一个字段的值追加值
Table.prototype.appendValue = function ({val, rowIdx, fieldId, fieldType}) {
  if (!val) {
    return
  }
  if (Object.prototype.toString.call(val) === '[object Array]') {
    const rowValue = this.value[rowIdx - 1]
    if (!rowValue) {
      console.log('error--value not exist')
      return
    }
    const fieldValue = rowValue[fieldId]
    console.log('rowIdx--', rowIdx, rowValue, fieldValue)
    if (fieldType === FORM_ITEM__IMAGE) {
      val.forEach(item => {
        const existItem = fieldValue.filter(img => img.id === item.id)[0]
        if (existItem) {
          existItem.imgName = item.imgName
          existItem.imgSize = item.imgSize
          existItem.imgUrl = item.imgUrl
          existItem.status = 'success'
        } else {
          fieldValue.push(item)
        }
      })
    }
    this.computeDisplayResults(rowIdx - 1)
  }
}

// 替换某一行的一个filed的value值
Table.prototype.replaceValue = function ({val, rowIdx, fieldId}) {
  if (!val) {
    return
  }
  const rowValue = this.value[rowIdx - 1]
  if (!rowValue) {
    console.log('error--value not exist')
    return
  }
  let fieldValue = rowValue[fieldId]
  if (isArray(fieldValue) && fieldValue) {

    fieldValue.splice(0, fieldValue.length, ...val)

  } else if (isObject(fieldValue) && fieldValue) {

    Object.keys(fieldValue).forEach(key => {
      if (val.hasOwnProperty(key)) {
        fieldValue[key] = val[key]
      }
    })

  } else {
    rowValue[fieldId] = val
  }
  this.computeDisplayResults(rowIdx - 1)
}

Table.prototype.updateValue = function (val) {
  if (!val) {
    return
  }
  val.forEach(item => {
    if (!item.id) {
      const id = uuid('tb')
      item.newId = id
      item.id = id
      context.$set(item, 'rowCustom', {})
      context.$set(item, 'optionsMap', {})
      this.children.forEach(field => {
        context.$set(item.rowCustom, field.dataId, {
          showCustom: 0,
          color: field.displayInfo.color,
          alertMsg: field.displayInfo.alertMsg
        })
        if ([FORM_ITEM__SINGLE_CHOOSE, FORM_ITEM__DROPDOWN, FORM_ITEM__CHECKBOX].includes(field.type)) {
          context.$set(item.optionsMap, field.dataId, field.options)
        }
      })
      this.value.push(item)
    } else {
      const oldValue = this.value.filter(v => v.id === item.id)[0]
      if (oldValue) {
        Object.keys(item).forEach(key => {
          if (oldValue.hasOwnProperty(key)) {
            oldValue[key] = item[key]
          }
        })
      }
      context.$set(oldValue, 'rowCustom', {})
      this.children.forEach(field => {
        context.$set(oldValue.rowCustom, field.dataId, {
          showCustom: 0,
          color: field.displayInfo.color,
          alertMsg: field.displayInfo.alertMsg
        })
      })
    }
  })
  this.value.forEach((row, idx) => {
    this.computeDisplayResults(idx)
  })
}

// 更新指定选项类控件的options
Table.prototype.updateOptions = function({fieldId, rowIdx, opts}) {
  const rowValue = this.value[rowIdx - 1]
  if (!rowValue) {
    console.log('error--value not exist')
    return
  }
  const optionsMap = rowValue['optionsMap']
  context.$set(optionsMap, fieldId, opts)
}

Table.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    defaultValue: this.defaultValue,
    closeTableCreate: this.closeTableCreate,
    closeTableDelete: this.closeTableDelete,
    allExpand: this.allExpand,
    openDataLoad: this.openDataLoad,
    dataLoadConfig: this.dataLoadConfig,
    dataLoadList: this.dataLoadList,
    showTableStyle: this.showTableStyle,

    quickGroup: this.quickGroup,
    quickGroupButton: this.quickGroupButton,
    openTableCreate: this.openTableCreate,
    startFormButton: this.startFormButton,
    startFormInfo: this.startFormInfo
  }
}
Table.prototype.setConf = function (opts) {
  this.setBase(opts)
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    this.closeTableCreate = opts.closeTableCreate
    this.closeTableDelete = opts.closeTableDelete
    this.allExpand = opts.allExpand
    if (opts.openDataLoad) this.openDataLoad = opts.openDataLoad
    if (opts.dataLoadConfig) this.dataLoadConfig = opts.dataLoadConfig
    if (opts.dataLoadList) this.dataLoadList = opts.dataLoadList

    if (opts.quickGroup) this.quickGroup = opts.quickGroup
    if (opts.quickGroupButton) this.quickGroupButton = opts.quickGroupButton
    if (opts.openTableCreate) this.openTableCreate = opts.openTableCreate
    if (opts.startFormButton) this.startFormButton = opts.startFormButton
    if (opts.startFormInfo) this.startFormInfo = opts.startFormInfo

    if (this.openDataLoad === 'YES' && this.dataLoadConfig) {
      const item = clone(this.dataLoadConfig)
      item.key = uuid()
      item.buttonTitle = '数据加载'
      item.bgColor = '#4A66FA'
      item.textColor = '#ffffff'
      this.dataLoadList.push(item)
      this.dataLoadConfig = null
    }
    if (opts.showTableStyle) this.showTableStyle = opts.showTableStyle
    // 自定义需要特殊处理
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
      this.defaultValue.customValue.forEach(val => {
        let opts = {}
        this.children.map(field => {
          // 单行文本需要处理一下自动生成唯一标识符
          opts[field.dataId] = val[field.dataId] || null
        })
        opts.rowCustom = val.rowCustom
        opts.optionsMap = val.optionsMap
        const id = uuid('tb')
        opts.id = id
        opts.newId = id

        this.value.push(opts)
      })
    }
  }
}
Table.prototype.defaultValueList = [
  {
    label: '不设置',
    value: {
      defaultType: ''
    }
  },
  {
    label: '关联数据',
    value: defaultValueInit(DEFAULT_VALUE__RELATE_DATA)
  }
]
Table.prototype.subsetOptional = [
  SingleLine,   // 单行文本
  Digital,      // 数字
  Currency,     // 金额
  DateInput,    // 日期
  DateRange,    // 日期区间
  DropDown,     // 下拉
  YesNo,        // 是否
  ExternalDataSource  // 数据来源
]
Table.prototype.addRow = function () {
  const opts = this.createValue()
  this.value.push(opts)
}
Table.prototype.addRowToIndex = function (index) {
  const opts = this.createValue()
  this.value.splice(index, 0, opts);
}
Table.prototype.createValue = function () {
  let opts = {
    rowCustom: {},
    optionsMap: {}
  }
  const id = uuid('tb')
  opts.id = id
  opts.newId = id
  this.children.map(field => {
    // 单行文本需要处理一下自动生成唯一标识符
    if (field.type === FORM_ITEM__SINGLE_LINE) {
      if (field.defaultValue.defaultType === DEFAULT_VALUE__ID) {
        opts[field.dataId] = uuid('No.')
      } else if (field.defaultValue.defaultType === DEFAULT_VALUE__SUB_TABLE_ID) {
        context.$set(this.reqSerMap, `${opts.id}_${field.dataId}`, true)
        store.dispatch('actionFetchSubTableSerialNumber', {
          appId: this.root.appId,
          formId: this.root.formId,
          fieldId: field.dataId
        }).then(res => {
          context.$set(opts, field.dataId, res.serialNo)
          delete this.reqSerMap[`${opts.id}_${field.dataId}`]
        }).catch(console.error)
      } else {
        opts[field.dataId] = field.getValue()
      }
    } else {
      const value = field.getValue()
      if (isObject(value) || value instanceof Array) {
        opts[field.dataId] = clone(value)
      } else if (field.type === FORM_ITEM__NUMBER || field.type === FORM_ITEM__CURRENCY) {
        opts[field.dataId] = value
      } else {
        opts[field.dataId] = value
      }
    }
    if ([FORM_ITEM__SINGLE_CHOOSE, FORM_ITEM__DROPDOWN, FORM_ITEM__CHECKBOX].includes(field.type)) {
      opts.optionsMap[field.dataId] = field.options
    }
    opts.rowCustom[field.dataId] = {
      showCustom: 0,
      color: field.displayInfo.color,
      alertMsg: field.displayInfo.alertMsg
    }
  })

  return opts
}
// 将 value 重置默认状态 一般修改过 children 需要调用
Table.prototype.resetValue = function () {
  this.value.splice(0, this.value.length)
  this.addRow()
}

// 修改value中的RowCustom，可能修改一个row，也可能修改所有row
Table.prototype.modifyRowCustom = function (opt) {
  const {
    rowIdx
  } = opt

  let rowCustom = {
    rowCustom: {}
  }
  this.children.forEach(field => {
    rowCustom.rowCustom[field.dataId] = {
      showCustom: 0,
      color: field.displayInfo.color,
      alertMsg: field.displayInfo.alertMsg
    }
  })

  if (rowIdx) {
    const row = this.value[rowIdx]
    if (!row.rowCustom) {
      row.rowCustom = clone(rowCustom.rowCustom)
    }
    this.computeDisplayResults(rowIdx)
  } else {

    this.value.forEach((row, idx) => {
      if (!row.rowCustom) {
        row.rowCustom = clone(rowCustom.rowCustom)
      }
      this.computeDisplayResults(idx)
    })
  }
}

// 计算子表单显隐藏结果
Table.prototype.computeDisplayResults = function (rowIndex) {
  // 计算当前行数据过滤添加结果
  const displayResults = {}
  Object.keys(this.displayRuleMap).forEach(key => {
    const filterInfo = this.displayRuleMap[key]
    displayResults[key] = getFilterResults(filterInfo, this.value[rowIndex])
  })

  // 保存当前行过滤结果
  this.displayResults[rowIndex] = displayResults

  // 拿到当前行的样式对象
  if (!this.value[rowIndex].rowCustom) {
    this.value[rowIndex].rowCustom = {
      showCustom: 0,
      color: '#ffffff',
      alertMsg: ''
    }
  }
  const rowCustom = this.value[rowIndex].rowCustom

  this.children.forEach(field => {
    // 拿到field的规则Id
    const keys = Object.keys(field.fieldCustomRuleMap) || []

    for (let i = 0; i < keys.length; i++) {
      // 拿规则Id循环找结果
      const displayId = keys[i]
      const result = displayResults[displayId]

      if (result) {
        const custom = field.fieldCustomRuleMap[displayId]
        rowCustom[field.dataId].showCustom = 1
        rowCustom[field.dataId].color = custom.customColor
        rowCustom[field.dataId].alertMsg = custom.alertMsg
        break
      } else {
        rowCustom[field.dataId].showCustom = 0
        rowCustom[field.dataId].color = '#ffffff'
        rowCustom[field.dataId].alertMsg = ''
      }
    }
  })
}
export default Table
